const tables = [
  {
    name: "Name",
  },
  {
    name: "Unit",
  },
  {
    name: "Category",
  },
  {
    name: "Brand",
  },
  {
    name: "Stock",
  },
  {
    name: "Status",
  },
  {
    name: "Action",
  },
];

export default tables;
